import React from 'react'
import { RouteConfig } from '.'
import { Navigate, Route, Routes } from 'react-router-dom'
import { isArray } from 'lodash'

interface RoutesContentProps {
  routes: RouteConfig[]
}

export const RoutesContent: React.FC<RoutesContentProps> = props => {
  const { routes } = props
  const defaultRoute = routes.find(route => !!route.isDefault)

  return (
    <Routes>
      {defaultRoute && <Route path={'/'} element={<Navigate to={defaultRoute.url} replace />} />}
      {routes
        .filter(route => route.redirectTo)
        .map(({ redirectTo, url }) => {
          if (isArray(redirectTo)) {
            const [path] = redirectTo.filter(r => !!routes.find(route => route.url === r))
            return path && <Route key={path} path={url} element={<Navigate to={path} replace />} />
          }

          return <Route key={redirectTo} path={url} element={<Navigate to={redirectTo!} replace />} />
        })}
      {routes.map(route => {
        return <Route key={route.url} path={route.url} element={route.content} />
      })}
    </Routes>
  )
}
